import DataType from "../constants/DataType";
import React from "react";
import {sorter} from "../util/arrayUtils";

const stringColumn = (key, title) => ({
    key,
    dataIndex: key,
    title,
    type: DataType.TEXT,
    required: true,
    validationRules: [{min: 2}, {max: 50}],
    sorter: (a, b) => sorter(a, b, key)
});

const numberColumn = (key, title) => ({
    key,
    dataIndex: key,
    title,
    type: DataType.DOUBLE,
    required: true,
    validationRules: [{min: 2}, {max: 50}],
    sorter: (a, b) => sorter(a, b, key)
});

const textAreaColumn = (key, title, optional) => ({
    key,
    dataIndex: key,
    title,
    type: DataType.TEXTAREA,
    required: !optional,
    validationRules: [{min: 2}, {max: 250}],
    sorter: (a, b) => sorter(a, b, key)
});

const selectColumn = (key, title, optional, url, displayColumn, tooltip) => {
    const column = {
        key,
        dataIndex: key,
        title,
        type: DataType.SELECT,
        required: !optional,
        url,
        optionsLinkFetch: url,
        displayColumn,
        tooltip,
        sorter: (a, b) => sorter(a, b, key)
    };
    if (!optional)
        column.validationRules = [{required: true, message: `Please select ${title}!`}];
    return column;
};

export {stringColumn, textAreaColumn, numberColumn, selectColumn}